(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockTarifauskunftsdatum', {
            require: {
                form: '^form'
            },
            bindings: {
                datum: '<abtDatum',
                type: '@abtType',
                label: '<abtLabel',
                options: '<abtOptions',
                triggerChanges: '<abtTriggerChanges',
                onChanged: '&abtOnChanged'
            },
            transclude: {
                tooltip: '?tooltip'
            },
            templateUrl: 'bloecke/tarifauskunftsdatum/blockTarifauskunftsdatum.html',
            controller: BlockTarifauskunftsdatumController,
            controllerAs: 'tarifauskunftsdatumVm'
        });

    BlockTarifauskunftsdatumController.$inject = [
        '$scope',
        '$log',
        '$modal',
        '$filter',
        '$transclude',
        '$element',
        'lodash',
        'moment',
        'AppConfig',
        'AngebotModel',
        'BasisAngebotService',
        'AngebotUtilsService',
        'MiscUtilsService',
        'FormFieldUtilsService',
        'NavigationService'
    ];
    function BlockTarifauskunftsdatumController($scope, $log, $modal, $filter, $transclude, $element, _, moment, AppConfig, AngebotModel, BasisAngebotService, AngebotUtilsService, MiscUtilsService, FormFieldUtilsService, NavigationService) {
        var vm = this,
            modalNeuerTarif,
            angebotAenderbar,
            AngebotSpezifischService,
            datumPath;

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;

        vm.isDisabled = isDisabled;
        vm.isRueckwirkenderVertragsbeginnErlaubt = isRueckwirkenderVertragsbeginnErlaubt;
        vm.onBlurTarifauskunftsdatum = onBlurTarifauskunftsdatum;

        function activate() {
            vm.angebotModel = AngebotModel.get();
            vm.options = vm.options || {};
            AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(vm.angebotModel.angebot) + 'Service');
            angebotAenderbar = BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANGEBOT');
            vm.type = vm.type || BasisAngebotService.getTarifauskunftsdatumType(vm.angebotModel.angebot);
            vm.tooltipTranscludeExists = $transclude.isSlotFilled('tooltip') && vm.options.hasTooltipSlot;

            vm.datumLabel = getLabel();
            datumPath = BasisAngebotService.getTarifauskunftsdatumPath();

            vm.tarifauskunftsdatum = _.get(vm.angebotModel.angebot, datumPath);

            handleDatumRegeln();
            handleDatumAenderung(_.get(vm.angebotModel.angebot, datumPath), _.get(vm.angebotModel.angebot, datumPath));
        }

        function onInit() {
            activate();

            $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                activate();
                if (angebotAenderbar && vm.type === 'tarifauskunftsdatum') {
                    BasisAngebotService.setVersicherungsbeginn(vm.angebotModel.angebot, true);
                }
            });

            $scope.$watch(function () {
                return _.get(vm.angebotModel.angebot, datumPath);
            }, function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    vm.tarifauskunftsdatum = newVal;
                    onChangedtarifauskunftsdatum(newVal, oldVal);
                }
            });
        }

        function onChanges() {
            vm.datumLabel = getLabel();

            handleDatumRegeln();
            vm.tooltipTranscludeExists = $transclude.isSlotFilled('tooltip') && vm.options.hasTooltipSlot;

            if (datumPath) {
                vm.tarifauskunftsdatum = _.get(vm.angebotModel.angebot, datumPath);
            }
        }

        function handleDatumRegeln() {
            vm.datumRegeln = getDatumRegeln();

            vm.placeholders = {
                tarifauskunftsdatum: {
                    min: [
                        $filter('date')(_.get(vm.datumRegeln, 'min'), 'dd.MM.yyyy'),
                        $filter('date')(_.get(vm.datumRegeln, 'max'), 'dd.MM.yyyy')
                    ],
                    max: [
                        $filter('date')(_.get(vm.datumRegeln, 'min'), 'dd.MM.yyyy'),
                        $filter('date')(_.get(vm.datumRegeln, 'max'), 'dd.MM.yyyy')
                    ],
                    'min, max': [
                        $filter('date')(_.get(vm.datumRegeln, 'min'), 'dd.MM.yyyy'),
                        $filter('date')(_.get(vm.datumRegeln, 'max'), 'dd.MM.yyyy')
                    ]
                }
            };
        }

        function getLabel() {
            return vm.label || (vm.type === 'versicherungsbeginn' ? 'Wann soll Ihr Versicherungsschutz beginnen?' : 'Zu welchem Datum möchten Sie Ihre Tarifauskunft berechnen?');
        }

        function onChangedtarifauskunftsdatum(newVal, oldVal) {
            if (newVal !== oldVal) {
                if (vm.type === 'tarifauskunftsdatum') {
                    BasisAngebotService.setVersicherungsbeginn(vm.angebotModel.angebot);
                }

                if (MiscUtilsService.isNotEmpty(newVal)) {
                    handleDatumAenderung(newVal, oldVal);
                }
            }
        }
        function getDatumRegeln() {
            if (!angebotAenderbar || isDisabled()) {
                return {
                    min: '',
                    max: ''
                };
            }

            if (vm.type === 'versicherungsbeginn') {
                return BasisAngebotService.getVersicherungsbeginnRegeln(vm.angebotModel.angebot);
            } else {
                return BasisAngebotService.getAngebotsdatumRegeln(vm.angebotModel.angebot);
            }
        }
        function isDisabled() {
            return (
                _.get(vm.angebotModel.angebot, 'aenderbareTarifmerkmale.angebotsdatum') === false
            );
        }
        function handleDatumAenderung(tarifauskunftsdatumNeu, tarifauskunftsdatumAlt) {
            var aktuellerTarif = _.get(vm.angebotModel, 'tarif') || {},
                tarifrechnerTarif = AppConfig.ANGEBOT.tarifkuerzel,
                tarifrechnerTarifbeginn = AppConfig.ANGEBOT.tarifbeginn;

            if (!BasisAngebotService.isAngebotAenderbar(vm.angebotModel.angebot, 'ANGEBOT') || MiscUtilsService.isEmpty(tarifauskunftsdatumNeu)) {
                return;
            }
            if (tarifauskunftsdatumNeu !== tarifauskunftsdatumAlt) {
                NavigationService.setFollowingDisabled(true);
            }

            if (AppConfig.ANGEBOT.disableTarifgenerationHandling === true || AngebotUtilsService.isTarifauskunftsdatumInTarifgeneration(tarifauskunftsdatumNeu, aktuellerTarif) && _.toLower(aktuellerTarif.tarifkuerzel) === _.toLower(tarifrechnerTarif)) {
                $log.debug('handleDatumAenderung Tarifauskunftsdatum innerhalb der Grenzen der Tarifgeneration', tarifauskunftsdatumNeu, tarifauskunftsdatumAlt, aktuellerTarif, tarifrechnerTarif);
                FormFieldUtilsService.handlePending(vm.allgemeinForm, 'wechsleTarif', false);

                if (tarifauskunftsdatumNeu !== tarifauskunftsdatumAlt) {
                    vm.onChanged({
                        tarifauskunftsdatum: tarifauskunftsdatumNeu
                    });
                }
            } else {
                $log.debug('handleDatumAenderung Tarifauskunftsdatum außerhalb der Grenzen der Tarifgeneration', tarifauskunftsdatumNeu, tarifauskunftsdatumAlt, aktuellerTarif, tarifrechnerTarif);
                FormFieldUtilsService.handlePending(vm.allgemeinForm, 'wechsleTarif', true);

                modalNeuerTarif = $modal.open({
                    templateUrl: 'modal/modalNeuerTarif.html',
                    windowClass: 'medium',
                    controller: 'ModalNeuerTarifController',
                    controllerAs: 'modalVm'
                });

                modalNeuerTarif.result.then(function () {
                    return AngebotModel.getTarifgeneration(tarifauskunftsdatumNeu).then(function (tarifNeu) {
                        AngebotUtilsService.wechsleTarifgeneration(tarifauskunftsdatumNeu, tarifNeu.tarifkuerzel, tarifrechnerTarif);
                    });
                }).catch(function (error) {
                    if (tarifauskunftsdatumAlt === tarifauskunftsdatumNeu && moment(tarifauskunftsdatumAlt, AppConfig.API.dateFormat).isBefore(tarifrechnerTarifbeginn, AppConfig.ANGEBOT.tarifbeginn)) {
                        AngebotModel.getTarifgeneration(tarifrechnerTarifbeginn).then(function () {
                            _.set(vm.angebotModel.angebot, datumPath, tarifrechnerTarifbeginn);
                            FormFieldUtilsService.handlePending(vm.allgemeinForm, 'wechsleTarif', false);
                        });
                    } else {
                        _.set(vm.angebotModel.angebot, datumPath, tarifauskunftsdatumAlt);
                    }

                    _.set(vm.angebotModel, 'showTarifWechselModal', false);

                    focusElementAfterCloseModal();
                }).finally(function () {
                    FormFieldUtilsService.handlePending(vm.form, 'wechsleTarif', false);

                    if (tarifauskunftsdatumNeu !== tarifauskunftsdatumAlt) {
                        vm.onChanged({
                            tarifauskunftsdatum: tarifauskunftsdatumNeu
                        });
                    }

                    focusElementAfterCloseModal();
                });
            }
        }
        function isRueckwirkenderVertragsbeginnErlaubt() {
            if (AngebotSpezifischService && angular.isFunction(AngebotSpezifischService.isRueckwirkenderVertragsbeginnErlaubt)) {
                return AngebotSpezifischService.isRueckwirkenderVertragsbeginnErlaubt(vm.angebotModel);
            }

            return false;
        }

        function focusElementAfterCloseModal() {
            if (!$element || !$element[0] || !$element[0].querySelector('input[date]')) {
                return;
            }

            $element[0].querySelector('input[date]').focus();
        }

        function onBlurTarifauskunftsdatum(tarifauskunftsdatum) {
            vm.angebotModel = vm.angebotModel || {};

            if (datumPath && tarifauskunftsdatum !== _.get(vm.angebotModel.angebot, datumPath, tarifauskunftsdatum)) {
                onChangedtarifauskunftsdatum(tarifauskunftsdatum, _.get(vm.angebotModel.angebot, datumPath));

                _.set(vm.angebotModel.angebot, datumPath, tarifauskunftsdatum);
            }
        }
    }

})();
